export const GIT_COMMIT = '0878abec6a3bbf6db26850b930f997a13443097a';
